module.exports = __webpack_public_path__ + "static/media/BrowserSafari.eff79f77.png";